import { render, staticRenderFns } from "./SideMenuNovel.vue?vue&type=template&id=fb3d4eb8&scoped=true"
import script from "./SideMenuNovel.vue?vue&type=script&lang=ts"
export * from "./SideMenuNovel.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuNovel.vue?vue&type=style&index=0&id=fb3d4eb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3d4eb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3d4eb8')) {
      api.createRecord('fb3d4eb8', component.options)
    } else {
      api.reload('fb3d4eb8', component.options)
    }
    module.hot.accept("./SideMenuNovel.vue?vue&type=template&id=fb3d4eb8&scoped=true", function () {
      api.rerender('fb3d4eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SideMenuNovel.vue"
export default component.exports